import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface CollectionPageStylesClasses {
  collectionPage: string;
  collectionContainer: string;
  loading: string;
  largeVideoSection: string;
  itemsContainer: string;
  gridItems: string;
}

const useCollectionPageStyles = makeStyles<Theme>((theme) => ({
  collectionPage: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100vh',
  },
  collectionContainer: {
    display: 'flex',
    marginTop: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90vh',
    margin: 'auto',
    width: '50%',
  },
  largeVideoSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  itemsContainer: {
    height: '100%',
    minHeight: '100%',
    maxHeight: '100%',
  },
  gridItems: {
    margin: '1rem',
    position: 'relative',
  },
}));

export type { CollectionPageStylesClasses };
export default useCollectionPageStyles;
